
// import {createGDMap} from '@/util/util.js'
// createGDMap();
// import AMap from 'vue-amap';
// console.log(AMap)
// Vue.use(AMap);

import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router/index'
import store from './store'

import MintUI from 'mint-ui'
Vue.use(MintUI)
import 'mint-ui/lib/style.css'
import 'src/css/reset.css'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'yHVt3rkXPnQDQW51WVrdyljYkoMWvNdL'
})
Vue.config.productionTip = false


var vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

export const bus = new Vue();



// WEBPACK FOOTER //
// ./src/main.js